import { StrAddressMapping } from "@/components/non_registrant/str-address-mapping";
import {
  rememberListingCity,
  rememberedListingCity,
} from "@/lib/str-address-mapping-city-memory";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

function listingCityFromSearch(value: unknown): string | undefined {
  if (typeof value !== "string") return undefined;
  const trimmed = value.trim();
  return trimmed || undefined;
}

export const Route = createFileRoute("/operator/str_/address-mapping")({
  validateSearch: (search: Record<string, unknown>) => {
    const listingCity = listingCityFromSearch(search.listingCity);
    return {
      listingId:
        typeof search.listingId === "string" ? search.listingId : undefined,
      propertyListingId:
        typeof search.propertyListingId === "string"
          ? search.propertyListingId
          : undefined,
      returnTo:
        typeof search.returnTo === "string" ? search.returnTo : undefined,
      ...(listingCity ? { listingCity } : {}),
    };
  },
  component: AddressMappingRoute,
});

function AddressMappingRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const storedListingCity = rememberedListingCity();
  const listingCity = search.listingCity ?? storedListingCity;

  useEffect(() => {
    if (search.listingCity || !storedListingCity) return;
    void navigate({
      search: {
        listingId: search.listingId,
        propertyListingId: search.propertyListingId,
        returnTo: search.returnTo,
        listingCity: storedListingCity,
      },
      replace: true,
    });
  }, [navigate, search, storedListingCity]);

  return (
    <StrAddressMapping
      listingId={search.listingId}
      propertyListingId={search.propertyListingId}
      returnTo={search.returnTo}
      listingCity={listingCity}
      onListingCityChange={(listingCity) => {
        rememberListingCity(listingCity);
        void navigate({
          search: {
            listingId: search.listingId,
            propertyListingId: search.propertyListingId,
            returnTo: search.returnTo,
            ...(listingCity ? { listingCity } : {}),
          },
          replace: true,
        });
      }}
    />
  );
}
